import { render, staticRenderFns } from "./znjk.vue?vue&type=template&id=222c8c28&scoped=true&"
import script from "./znjk.vue?vue&type=script&lang=js&"
export * from "./znjk.vue?vue&type=script&lang=js&"
import style0 from "./znjk.vue?vue&type=style&index=0&id=222c8c28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222c8c28",
  null
  
)

export default component.exports